export default "__VITE_ASSET__34f4e08a__"